import { GET_SEMINAR_SPECIFICS, GET_SEMINAR } from '../constants';
import { getContent } from '../../services/api';

export const fetchSeminar = (slug, locale) => ({
  type: GET_SEMINAR,
  payload: getContent({ contentType: 'seminarSpecifics', slug, locale }),
});

export const fetchSeminars = ({ filters = {}, limit, locale, skip }) => ({
  type: GET_SEMINAR_SPECIFICS,
  // payload: getContent({ contentType: 'seminars', skip, limit, locale, ...filters }),
  payload: getContent({ contentType: 'seminars', locale, ...filters }),
});



// WEBPACK FOOTER //
// ./src/redux/actions/seminars.js